///<require types="modernizr" />

import * as $ from "jquery";
import * as angular from "angular";
import * as _ from "lodash"

import "imports-loader?this=>window!./Scripts/modernizr-custom";

import { AccountModel } from "./Common/Models/AccountModel";
import "./Common/Models/AccountModel";

import { AssetsModel } from "./Common/Models/AssetsModel";
import "./Common/Models/AssetsModel";

import { AuthorizationModel } from "./Common/Models/AuthorizationModel";
import "./Common/Models/AuthorizationModel";

import { BaseModel, AtonixAuthenticationService, AtonixAuthenticationConstants, AtonixRedirector } from "./Common/Models/model";
import "./Common/Models/model";

import { Notifications } from "./Common/Notifications/Notifications";
import "./Common/Notifications/Notifications";

import "./Common/Notifications/Overlay";

interface IUnauthorizedScope extends angular.IScope {

}

class UnauthorizedController implements angular.IController {
	public State: 'login' | 'requestpw' | 'changepw' | 'initialpw' | 'mfa' | 'navigate' = 'login'; //Can be login,requestpw,changepw,mfa,navigate
	public LockEmail: boolean = false;
	private returnUrl: string;
	public Email: string;
	public Name: string;
	public Password: string;
	public PasswordVerify: string;
	public Code: string;
	public RememberMe: boolean;
	public Challenge: string;
	public PasswordChangeMessage: string;

	public AppContexts: model.IAppContext[];

	public InfoMessage: string;
	public ErrorMessage: string;
	public Busy: boolean = false;

	public SetInfo(newMessage: string) {
		this.ErrorMessage = null;
		this.InfoMessage = newMessage;
	}

	public SetError(newMessage: string) {
		this.ErrorMessage = newMessage;
		this.InfoMessage = null;
	}

	public ClearMessage() {
		this.ErrorMessage = null;
		this.InfoMessage = null;
	}

	constructor(private $location: angular.ILocationService, private $window: angular.IWindowService, private atonixAuthenticationService: AtonixAuthenticationService, private assetsModel: AssetsModel, private accountModel: AccountModel, private authorizationModel: AuthorizationModel, private notifications: Notifications) {

		let state = $location.search().state || null;
		this.returnUrl = null;

		if (state && window && window.localStorage) {
			this.returnUrl = window.localStorage.getItem("REDIRECTSTATE:" + state) || null;
		}

		this.RememberMe = true;

		this.Busy = true;
		this.authorizationModel.getCognitoSettings()
			.then((settings) => {
				this.atonixAuthenticationService.ClientID(settings.ClientID);
				this.atonixAuthenticationService.UserPoolID(settings.PoolID);
				this.atonixAuthenticationService.AuthFlowType(settings.AuthFlowType);
				this.atonixAuthenticationService.Initialize();
			})
			.catch((err) => {
				console.log("Error getting authentication information:" + JSON.stringify(err));
			})
			.finally(() => {
				this.Busy = false;
			});

	}

	private setBusy() {
		this.Busy = true;
		this.notifications.showOverlay();
	}

	private clearBusy() {
		this.Busy = false;
		this.notifications.hideOverlay();
	}

	private setState(newState: "login" | "requestpw" | "changepw" | "initialpw" | "mfa" | "navigate") {
		this.State = newState;
	}

	private clearState() {
		this.setState("login");
	}

	private GetNameFromUserAttributes(attributes: { name: string }) {
		let result: string = "";
		if (attributes) {
			result = attributes.name || "";
		}
		return result;
	}

	public Login() {
		this.setBusy();

		this.atonixAuthenticationService.Login(this.Email, this.Password, this.RememberMe)
			.then((result) => {
				if (result.Status === AtonixAuthenticationConstants.LoginSuccessful) {
					this.userAuthenticated();
				}
				else if (result.Status === AtonixAuthenticationConstants.MFARequired ||
					result.Status === AtonixAuthenticationConstants.TotpRequired) {
					this.mfaRequired(result.Challenge, result.ChallengeParameters);
				}
				else if (result.Status === AtonixAuthenticationConstants.PasswordChangeRequired) {
					this.Password = "";
					this.PasswordVerify = "";
					this.LockEmail = true;
					this.setState("changepw");
					this.Name = this.GetNameFromUserAttributes(result.UserAttributes);
				}
				else if (result.Status === AtonixAuthenticationConstants.InitialPasswordRequired) {
					this.Password = "";
					this.PasswordVerify = "";
					this.LockEmail = true;
					this.setState("initialpw");
					this.Name = this.GetNameFromUserAttributes(result.UserAttributes);
				}
			})
			.catch((ex: { code: string, name: string, message: string }) => {
				if (ex.code === "UserNotFoundException") {
					this.SetError("Could not log in, verify entries and try again");
				}
				else {
					this.SetError("Could not log in, verify entries and try again.");
				}
			})
			.finally(() => {
				this.clearBusy();
			});
	}

	public ForgotPassword() {
		this.ClearMessage();
		this.setState("requestpw");
	}

	public IHaveACode() {
		this.Password = null;
		this.PasswordVerify = null;
		this.ClearMessage();
		this.setState("changepw");
	}

	public RequestPW() {
		this.setBusy();
		this.accountModel.isUserFederated(this.Email)
			.then((federated) => {
				// ForgotPassword only available for non-Federated users
				if (!federated) {
					this.atonixAuthenticationService.ForgotPassword(this.Email)
						.then((prompt) => {
							this.Password = null;
							this.PasswordVerify = null;
							if (prompt.DeliveryMedium === "EMAIL") {
								this.PasswordChangeMessage = "An email has been sent to " + prompt.Destination + " containing a verification code.";
							}
							else if (prompt.DeliveryMedium === "SMS") {
								this.PasswordChangeMessage = "A message has been sent to the phone number " + prompt.Destination + " containing a verification code.";
							}
							this.setState("changepw");
						})
						.catch((err: { code: string, message: string, name: string }) => {
							if (err && err.code === "LimitExceededException") {
								this.SetError("Too many requests.  Try again later.");
								this.clearState();
							}
							else if (err && err.code === "UserNotFoundException") {
								this.InitializeUser(this.Email);
							}
							else {
								this.SetError("Request Password Change Failed");
								
							}
						});
				}
				else
				{
					this.SetError("Password reset not available for federated users.");
					this.clearState();
				};
			})
			.finally(() => {
				this.clearBusy();
			});
	}

	private InitializeUser(email: string) {
		this.setBusy();
		this.accountModel.initializeUser(this.Email.toLowerCase())
			.then((result) => {
				if (result == "NoUser") {
					this.SetInfo("Contact support@atonix.com to create an account.");
				}
				else if (result == "UserExists") {
					this.SetError("Could not reset password.");
				}
				else if (result == "Federated") {
					this.SetError("Password reset not available for federated users.");
                }
				else if (result) {
					this.SetError("Error resetting password.");
				}
				else {
					this.SetInfo("A temporary password has been sent to " + email);
				}
			})
			.catch(() => {
				this.SetError("Could not reset password.");
			})
			.finally(() => {
				this.clearState();
				this.clearBusy();
			});
	}

	public ChangePW() {
		if (this.CheckPasswordMatch()) {
			this.setBusy();
			this.atonixAuthenticationService.ConfirmPassword(this.Email, this.Password, this.Code)
				.then(() => {
					return this.atonixAuthenticationService.Login(this.Email, this.Password, this.RememberMe);
				})
				.then((result) => {
					if (result.Status === AtonixAuthenticationConstants.LoginSuccessful) {
						this.userAuthenticated();
					}
					else if (result.Status === AtonixAuthenticationConstants.MFARequired) {
						this.mfaRequired(result.Challenge, result.ChallengeParameters);
					}
					else if (result.Status === AtonixAuthenticationConstants.TotpRequired) {
						this.mfaRequired(result.Challenge, result.ChallengeParameters);
					}
				})
				.catch(() => {
					this.SetError("Change Password Failed");
					this.Password = "";
					this.PasswordVerify = "";
					this.Code = "";
					this.clearState();
				})
				.finally(() => {
					this.clearBusy();
				});
		}
	}

	public InitialPW() {
		if (this.CheckPasswordMatch() && this.Name) {
			this.setBusy();

			this.atonixAuthenticationService.CompleteInitialPassword(this.Password, { name: this.Name })
				.then((result) => {
					if (result.Status === AtonixAuthenticationConstants.LoginSuccessful) {
						this.userAuthenticated();
					}
					else if (result.Status === AtonixAuthenticationConstants.MFARequired ||
						result.Status === AtonixAuthenticationConstants.TotpRequired) {
						this.mfaRequired(result.Challenge, result.ChallengeParameters);
					}
				})
				.catch((ex: { code: string, name: string, message: string }) => {
					if (ex.code === "InvalidPasswordException") {
						this.SetError(ex.message);
					}
					else {
						this.SetError("Could not set password, verify entries and try again.");
					}

				})
				.finally(() => {
					this.clearBusy();
				});
		}
	}

	public SubmitMFASMS() {
		this.setBusy();
		this.atonixAuthenticationService.FinishLoginSMS(this.Code)
			.then((result) => {
				if (result.Status === AtonixAuthenticationConstants.LoginSuccessful) {
					this.userAuthenticated();
				}
				else if (result.Status === AtonixAuthenticationConstants.MFARequired) {
					this.SetError("Code was invalid, try again.");
					this.mfaRequired();
				}
			})
			.catch(() => {
				this.SetError("Code was invalid, try again.");
			})
			.finally(() => {
				this.clearBusy();
			});
	}

	public SubmitMFASoftwareToken() {
		this.setBusy();
		this.atonixAuthenticationService.FinishLoginSoftwareToken(this.Code)
			.then((result) => {
				if (result.Status === AtonixAuthenticationConstants.LoginSuccessful) {
					this.userAuthenticated();
				}
				else if (result.Status === AtonixAuthenticationConstants.MFARequired) {
					this.SetError("Code was invalid, try again.");
					this.mfaRequired();
				}
			})
			.catch(() => {
				this.SetError("Code was invalid, try again.");
			})
			.finally(() => {
				this.clearBusy();
			});
	}

	public SubmitMFA() {
		if (this.Challenge) {
			this.SubmitMFASoftwareToken();
		}
		else {
			this.SubmitMFASMS();
		}
	}

	public CheckPasswordMatch() {
		let result: boolean = true;
		result = this.Password === this.PasswordVerify;
		return result;
	}

	private mfaRequired(challenge?: string, challengeParameters?: string) {
		this.Code = "";
		if (challenge) {
			this.Challenge = challenge;
		}
		else {
			this.Challenge = null;
		}
		this.setState("mfa");
		this.SetError(null);
	}

	private userAuthenticated() {
		this.setState("navigate");
		this.ClearMessage();
		//The user authenticated method tells the back end that the user was logged in so it can keep track of logins in the database. 
		//It supports the security provision of allowing a user (certain users) to only be logged in to one browser at a time.  
		this.accountModel.userAuthenticated()
			.then(() => {
				if (this.returnUrl) {
					this.SetInfo("Navigating ...");
					this.$window.location.href = this.returnUrl;
				}
				else {
					this.assetsModel.getAppContextsAndProcess()
						.then((ac) => {
							this.AppContexts = ac;

							if (this.AppContexts) {
								this.AppContexts.push({
									AppContextID: -1,
									DisplayName: "Account",
									DisplayOrder: 1000,
									Icon: null,
									Locale: null,
									Name: "Account",
									OpenInNew: false,
									Path: "/Account",
									Refresh: null,
									SecurityResourceID: null,
									ShowFuture: null,
									StartAsset: null,
									StopAtLevel: null,
									Tabs: null,
									TimeRange: null,
									TimeSelection: null
								});
							}
						});
				}
			}).catch(() => {
				this.notifications.error("An error occurred after authentication.");
			});
	}

	public $onInit() { };
	public $doCheck() { };
	public $onChanges(onChangesObj: angular.IOnChangesObject) { };
	public $onDestroy() { };
	public $postLink() { };
}


let app = angular.module('unauthorizedApp', ['model', 'directives']);
app.config(['$locationProvider', (locationProvider: angular.ILocationProvider) => {
	locationProvider.html5Mode(true);
}]);
app.controller('unauthorizedController', ['$location', '$window', 'AtonixAuthenticationService', 'assetsModel', 'accountModel', 'authorizationModel', 'notifications', ($location, $window, AtonixAuthenticationService, AssetsModel, accountModel, authorizationModel, notifications) => new UnauthorizedController($location, $window, AtonixAuthenticationService, AssetsModel, accountModel, authorizationModel, notifications)]);


// WEBPACK FOOTER //
// ./unauthorizedApp.ts